module.exports = __webpack_public_path__ + "img/edit_icon.19b24d51.svg";